// extracted by mini-css-extract-plugin
export default {"header":"style_header__GQgyr","content":"style_content__BXJS6","row":"style_row__Qcnr6"};